import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-gray-200 rounded-xl overflow-hidden mb-3" data-id="element-72">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors duration-200 cursor-pointer" aria-expanded={isOpen} data-id="element-73">
        <span className="text-base md:text-lg font-bold text-gray-900 font-heading pr-4" data-id="element-74">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-75" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-76">
        <p className="px-5 pb-5 text-gray-600 font-body text-base" data-id="element-77">{answer}</p>
      </div>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [{
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Recibirás acceso inmediato al contenido en formato digital (PDF) directamente en tu correo o pantalla de confirmación. Podrás descargarlo y empezar a usarlo en minutos.'
  }, {
    q: '¿Esto funciona si mi hijo no tiene diagnóstico de TDAH?',
    a: 'Sí. Este sistema está diseñado para niños con alta energía, intensidad o dificultad para regularse, tengan diagnóstico o no.'
  }, {
    q: '¿Sirve para mi país?',
    a: 'Sí. Está creado en español neutro y funciona en cualquier país hispanohablante, sin importar el contexto.'
  }, {
    q: '¿Necesito experiencia previa o conocimientos en psicología?',
    a: 'No. Está pensado para madres y padres. Todo está explicado de forma simple, clara y aplicable.'
  }, {
    q: '¿Los bonos están incluidos en todas las versiones?',
    a: 'Sí. Los 3 bonos (Kit Visual, Protocolos de Crisis y Plan 7 Días) están incluidos en todas las opciones sin costo extra.'
  }, {
    q: '¿Cuánto tiempo necesito para ver resultados?',
    a: 'Muchos padres comienzan a notar cambios en pocos días. Además, el plan “Modo Calma” está diseñado para generar mejoras en 7 días.'
  }, {
    q: '¿Qué pasa si mi hijo tiene crisis muy intensas?',
    a: 'El sistema incluye protocolos específicos para momentos de desborde, con pasos claros para actuar sin gritar ni empeorar la situación.'
  }, {
    q: '¿Funciona si ya probé otras cosas y nada me funcionó?',
    a: 'Sí, porque este no es un conjunto de consejos sueltos. Es un sistema estructurado que aborda la raíz del comportamiento.'
  }, {
    q: '¿Puedo aplicarlo si tengo más de un hijo?',
    a: 'Sí. Las estrategias son adaptables y puedes ajustarlas según cada niño y situación familiar.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en dólares, pero el pago se procesa automáticamente en la moneda de tu país.'
  }, {
    q: '¿Qué diferencia tiene este MegaPack con otros contenidos?',
    a: 'No es solo información. Es un sistema paso a paso, con herramientas listas para aplicar en casa, pensado para resultados reales.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 7 días de garantía total. Si no es lo que esperabas, puedes solicitar la devolución completa sin preguntas.'
  }];
  return <section className="w-full bg-white py-12 md:py-16 px-4" data-id="element-78">
      <div className="max-w-2xl mx-auto" data-id="element-79">
        <h2 className="text-3xl md:text-4xl font-black font-heading text-gray-900 text-center mb-10" data-id="element-80">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onToggle={() => toggle(index)} data-id="element-81" />)}
      </div>
    </section>;
}